//#region src/badge_category.ts
var BadgeCategory = /* @__PURE__ */ function(BadgeCategory) {
	BadgeCategory["Restrictive"] = "restrictive";
	BadgeCategory["Dietary"] = "dietary";
	BadgeCategory["Other"] = "other";
	BadgeCategory["NonFiltering"] = "non-filtering";
	BadgeCategory["Hidden"] = "hidden";
	BadgeCategory["Warning"] = "warning";
	return BadgeCategory;
}(BadgeCategory || {});
//#endregion
export { BadgeCategory };

//# sourceMappingURL=badge_category.js.map